import { createRouter, createWebHashHistory } from 'vue-router';
import DataDashboard from '../components/DataDashboard.vue';
import ResourcesPage from '../components/ResourcesPage.vue';
import ActionPlanPage from '../components/ActionPlanPage.vue';
import InsightsPage from '../components/InsightsPage.vue';
import App from '../App.vue';

const routes = [
  {
    path: '/',
    name: 'About',
    component: App,
  },
  {
    path: '/dashboard',
    name: 'DataDashboard',
    component: DataDashboard,
  },
  {
    path: '/action-plan',
    name: 'ActionPlan',
    component: ActionPlanPage,
  },
  {
    path: '/resources',
    name: 'Resources',
    component: ResourcesPage,
  },
  {
    path: '/research',
    redirect: () => 'resources',
  },
  {
    path: '/insights',
    name: 'Insights',
    component: InsightsPage,
  },
];

export default function router() {
  return createRouter({
    history: createWebHashHistory(),
    routes,
    // scrollBehavior() {
    //   return { top: 0 };
    // },
  });
}
// const routes = [{ path: '/home', redirect: { name: 'homepage' } }]
